var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0.722656H2C0.897 0.722656 0 1.61966 0 2.72266V11.7227C0 12.8257 0.897 13.7227 2 13.7227H18C19.103 13.7227 20 12.8257 20 11.7227V2.72266C20 1.61966 19.103 0.722656 18 0.722656ZM16.113 2.72266L10 6.54266L3.887 2.72266H16.113ZM2 11.7227V3.90166L9.47 8.57066C9.632 8.67166 9.816 8.72266 10 8.72266C10.184 8.72266 10.368 8.67166 10.53 8.57066L18 3.90066L18.001 11.7227H2Z",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.8d7c4ac24e5983a1b9d03a0c3a8aef20.svg";
export { ForwardRef as ReactComponent };